import { render, staticRenderFns } from "./Crew.vue?vue&type=template&id=2a6e7577&scoped=true&"
import script from "./Crew.vue?vue&type=script&lang=js&"
export * from "./Crew.vue?vue&type=script&lang=js&"
import style0 from "./Crew.vue?vue&type=style&index=0&id=2a6e7577&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6e7577",
  null
  
)

export default component.exports